import PropTypes from 'prop-types';
import React from 'react';

class UploadBar extends React.Component {

  render() {
    const {percentCompleted} = this.props;

    const style = {
      width: (percentCompleted || 0) + '%'
    };
    return (
      <div className="uploading-bar">
        <div className="upload-bar-bg"/>
        <div className="upload-bar-completed" style={style}/>
      </div>
    );
  }
}

UploadBar.propTypes = {
  percentCompleted: PropTypes.number
};

export default UploadBar;



// WEBPACK FOOTER //
// ./chat-app/components/UploadBar/UploadBar.js